import { render, staticRenderFns } from "./FileCard.vue?vue&type=template&id=55428330&scoped=true&"
import script from "./FileCard.vue?vue&type=script&lang=ts&"
export * from "./FileCard.vue?vue&type=script&lang=ts&"
import style0 from "./FileCard.vue?vue&type=style&index=0&id=55428330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55428330",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
